import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class DeviceService {
  getDeviceInfo() {
    const userAgent = navigator.userAgent
    const platform = navigator.platform
    const deviceType = this.getDeviceType()

    return {
      userAgent,
      platform,
      deviceType
    }
  }

  private getDeviceType(): string {
    const ua = navigator.userAgent
    if (/mobile/i.test(ua)) return 'Mobile'
    if (/iPad|Tablet/i.test(ua)) return 'Tablet'
    return 'Desktop'
  }
}
